export default "__VITE_ASSET__Bb0TJQzG__"